/** @jsxImportSource @emotion/react */
import { InformativePanel } from '@app/components/Molecules/RiskSideDrawerContent/tabs'
import { SideDrawer } from '@app/components/Molecules/SideDrawer'
import { riskMapInstanceAtom, riskMapPaddingRefAtom } from '@app/risk-migration/atoms/riskMap.atoms'
import { useRiskMapNavigation } from '@app/risk-migration/hooks/useRiskMapNavigation'
import { Box, useTheme } from '@mui/material'
import { useAtomValue } from 'jotai'
import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { LiveMapView } from './components/Live.MapView'
import { LiveContextProvider } from './contexts/Live.Context'
import { livePageContainer, sideDrawerContainer } from './Live.page.styles'
import { useLoadWorkspaceFromUrl } from '@app/components/Risk/Workspaces/hooks/useLoadWorkspaceFromUrl'

// Rendered inside LiveContextProvider so the loader can restore live layers
const LoadWorkspaceFromUrl = () => {
  useLoadWorkspaceFromUrl()
  return null
}

export const RexLivePage = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true)
  const theme = useTheme()
  const map = useAtomValue(riskMapInstanceAtom)
  const mapPaddingRef = useAtomValue(riskMapPaddingRefAtom)
  const { flyTo, getMapPadding } = useRiskMapNavigation()
  return (
    <LiveContextProvider>
      <LoadWorkspaceFromUrl />
      <Box css={livePageContainer} id="livePageContainer">
        <Box css={sideDrawerContainer}>
          <SideDrawer
            map={map}
            isOpen={isDrawerOpen}
            handleToggle={() => setIsDrawerOpen((open) => !open)}
            color={theme.palette.primary.main}
            side="left"
            initialWidth={600}
            handleWidthChange={(width: number) => {
              const { left: previousWidth } = getMapPadding(true)
              mapPaddingRef.current = { top: 0, left: width, bottom: 0, right: 0 }

              if (map && width !== previousWidth) {
                flyTo({
                  latitude: map.getCenter().lat,
                  longitude: map.getCenter().lng,
                  zoom: map.getZoom(),
                  usePadding: true,
                  duration: 800,
                })
              }
            }}
          >
            <InformativePanel />
          </SideDrawer>
        </Box>
        <LiveMapView />
      </Box>
      <Outlet />
    </LiveContextProvider>
  )
}
